'use strict';

var dropdownContent = angular.module('saturn.dropdown.content', []);

var DropdownContentDirective = require('./DropdownContentDirective');

// ## Directives

dropdownContent.directive('sbDropdownContent', [
  DropdownContentDirective
]);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dropdown/src/dropdownContent/index.js